module.exports = __webpack_public_path__ + "static/img/12.e5b5fd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/12.png
// module id = 93LJ
// module chunks = 0